var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectedOrders.length
    ? _c(
        "div",
        {
          staticClass: "bulk-action-container",
          class: {
            "normal-bulk-container":
              !_vm.actionsToDisplay.includes("batchAssign"),
          },
        },
        [
          _c("div", { staticClass: "bulk-text" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.selectedOrders.length) +
                " order" +
                _vm._s(_vm.selectedOrders.length > 1 ? "s" : "") +
                " selected.\n    "
            ),
          ]),
          _c("div", [
            _vm.actionsToDisplay.includes("sendSchedulingLink")
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-send-sms",
                    attrs: { title: "Send SMS" },
                    on: { click: _vm.sendSchedulingLink },
                  },
                  [_vm._v("\n            Send SMS\n        ")]
                )
              : _vm._e(),
            _vm.actionsToDisplay.includes("batchAssign")
              ? _c(
                  "button",
                  {
                    staticClass: "btn",
                    attrs: { title: "Batch Assign to Carrier" },
                    on: { click: _vm.handleBatchAssignClicked },
                  },
                  [_vm._v("\n            Batch Assign to Carrier\n        ")]
                )
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }